export default __webpack_public_path__ + "static/media/recipe-lg.95cf2e70.png";